/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ClinTrakStudyDataViewModel } from '../models/ClinTrakStudyDataViewModel';
import type { ClinTrakStudyVisitViewModel } from '../models/ClinTrakStudyVisitViewModel';
import type { StudyCtsm } from '../models/StudyCtsm';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class StudyClinTrakDataService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns StudyCtsm
     * @throws ApiError
     */
    public studyClinTrakDataGetStudies(): Observable<Array<StudyCtsm>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/studies',
        });
    }
    /**
     * @param studyId
     * @returns ClinTrakStudyDataViewModel
     * @throws ApiError
     */
    public studyClinTrakDataGetClinTrakStudyData(
        studyId: string,
    ): Observable<ClinTrakStudyDataViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/studies/studydata/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param pcsStudyId
     * @returns ClinTrakStudyDataViewModel
     * @throws ApiError
     */
    public studyClinTrakDataGetClinTrakStudyDataByPcsStudyId(
        pcsStudyId: number,
    ): Observable<ClinTrakStudyDataViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/studies/studydata/pcs/{pcsStudyId}',
            path: {
                'pcsStudyId': pcsStudyId,
            },
        });
    }
    /**
     * @param pcsStudyId
     * @returns string
     * @throws ApiError
     */
    public studyClinTrakDataGetClinTrakStudyStatusNameByPcsStudyId(
        pcsStudyId: number,
    ): Observable<string> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/studies/studystatus/pcs/{pcsStudyId}',
            path: {
                'pcsStudyId': pcsStudyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns number
     * @throws ApiError
     */
    public studyClinTrakDataRejectStudy(
        studyId: string,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/clintrak/studies/rejectstudy/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyCode
     * @returns ClinTrakStudyVisitViewModel
     * @throws ApiError
     */
    public studyClinTrakDataGetClinTrakStudyVisits(
        studyCode: string,
    ): Observable<ClinTrakStudyVisitViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/studies/study/visits/{studyCode}',
            path: {
                'studyCode': studyCode,
            },
        });
    }
}
